// removed by extract-text-webpack-plugin
module.exports = {"price":"pdp-price__price__2MFXP","portfolio":"pdp-price__portfolio__2ku6e pdp-price__price__2MFXP","sup":"pdp-price__sup__NaWcs","reduced":"pdp-price__reduced__15ffW"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/Price/pdp-price.scss
// module id = 633
// module chunks = 4 12 14 19